import { Button, Col, Container, Image, Row } from "react-bootstrap";
import MediaQueryTool from "../../utils/MediaQueryTool";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-coverflow";
import { Navigation, Pagination, EffectCoverflow } from "swiper/modules";
import tnc from "../../assets/IMG_0302.png";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { useEffect, useState } from "react";

const Commission = ({ setInquiryList }) => {
  const mediaQueryTool = MediaQueryTool();
  const [data, setData] = useState(null);

  const buttonStyle = {
    padding: "3px 12px",
    fontSize: !mediaQueryTool.isXS ? 16 : 12,
    marginBottom: mediaQueryTool.isXS ? 6 : undefined,
  };

  const showToast = () => {
    toast.success("Item have been added to the Inquired List", {
      position: "top-center",
      autoClose: 3000,
    });
  };

  useEffect(() => {
    axios
      .get("https://sugarno_backend.sugarnoproject.workers.dev/getCommission")
      .then((response) => {
        setData(response.data.data);
      })
      .catch((error) => console.error(error));
  }, []);

  return (
    <>
      {data && (
        <div style={{ color: "white" }}>
          <ToastContainer />
          <Container
            className="d-flex flex-column align-items-center"
            style={{
              marginTop: !mediaQueryTool.isXS ? 100 : 65,
              marginTBottom: mediaQueryTool.isXS ? 100 : undefined,
            }}
          >
            <h1
              className="neon-text2"
              style={{
                fontFamily: "CyberpunkFont",
              }}
            >
              Commission Details
            </h1>

            <a
              href="/pdf/commission.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button
                className="mt-3"
                style={{
                  padding: "0 12px 0 0",
                  fontSize: mediaQueryTool.isXS ? "12px" : "14px",
                }}
              >
                <Image
                  src={tnc}
                  style={{
                    height: !mediaQueryTool.isXS ? "50px" : "40px ",
                    padding: "5px",
                    borderTopLeftRadius: "5px",
                    borderBottomLeftRadius: "5px",
                    marginRight: "10px",
                    backgroundColor: "#133a94",
                  }}
                />
                Terms and Condition
              </Button>
            </a>
          </Container>

          {!mediaQueryTool.isXS ? (
            <Row
              className={`mt-2 g-5 d-flex align-items-center`}
              style={{
                paddingBottom: 100,
                paddingLeft: 100,
                paddingRight: 100,
              }}
            >
              {data.map((item, index) => (
                <Col key={index} xs={6} md={4}>
                  <Image
                    key={index}
                    style={{
                      width: "100%",
                      height: "20rem",
                      objectFit: "cover",
                      borderTopLeftRadius: 10,
                      borderTopRightRadius: 10,
                    }}
                    src={item.url}
                  />

                  <div
                    style={{
                      borderBottomLeftRadius: 10,
                      borderBottomRightRadius: 10,
                      padding: 20,
                      backgroundColor: "#263F5F",
                    }}
                  >
                    <div>
                      <h3>{item.name}</h3>
                      <h5 style={{ fontWeight: "bold" }}>RM {item.price}</h5>
                    </div>

                    <div>
                      <p
                        style={{
                          margin: 0,
                          fontSize: 16,
                          whiteSpace: "pre-line",
                          padding: `0px 0px 0px 16px`,
                        }}
                      >
                        {item.desc}
                      </p>
                    </div>

                    <div
                      className={`mx-2 mt-4`}
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      <Button
                        style={buttonStyle}
                        onClick={() => {
                          let inquiryList =
                            JSON.parse(localStorage.getItem("inquiryList")) ||
                            [];

                          inquiryList.push(
                            item.name + "(RM " + item.price + ")"
                          );

                          localStorage.setItem(
                            "inquiryList",
                            JSON.stringify(inquiryList)
                          );

                          setInquiryList(inquiryList);
                          showToast();
                        }}
                      >
                        Inquiry
                      </Button>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          ) : (
            <Swiper
              navigation
              pagination={{ clickable: true }}
              effect="coverflow"
              modules={[Navigation, Pagination, EffectCoverflow]}
              className="mySwiper mt-4 mb-5"
              loop
              grabCursor
              centeredSlides
              slidesPerView={2}
              coverflowEffect={{
                slideShadows: false,
              }}
              color="white"
              style={{ height: "100%", width: "100%", position: "relative" }}
            >
              {data.map((item, index) => (
                <SwiperSlide key={index} style={{ height: "auto" }}>
                  <Image
                    key={index}
                    style={{
                      width: "100%",
                      marginTop: 20,
                      height: "12rem",
                      objectFit: "cover",
                      borderTopLeftRadius: 10,
                      borderTopRightRadius: 10,
                    }}
                    src={item.url}
                  />

                  <div
                    style={{
                      borderBottomLeftRadius: 10,
                      borderBottomRightRadius: 10,
                      padding: 9,
                      backgroundColor: "#263F5F",
                    }}
                  >
                    <div>
                      <h5>{item.name}</h5>
                      <h6 style={{ fontWeight: "bold" }}>RM {item.price}</h6>
                    </div>

                    <div>
                      <p
                        style={{
                          margin: 0,
                          fontSize: 12,
                          whiteSpace: "pre-line",
                          padding: `0px 0px 0px 20px`,
                        }}
                      >
                        {item.desc}
                      </p>
                    </div>

                    <div
                      className={`mx-2 mt-3`}
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      <Button
                        style={buttonStyle}
                        onClick={() => {
                          let inquiryList =
                            JSON.parse(localStorage.getItem("inquiryList")) ||
                            [];

                          inquiryList.push(
                            item.name + "(RM " + item.price + ")"
                          );

                          localStorage.setItem(
                            "inquiryList",
                            JSON.stringify(inquiryList)
                          );

                          setInquiryList(inquiryList);

                          showToast();
                        }}
                      >
                        Inquiry
                      </Button>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          )}
        </div>
      )}
    </>
  );
};

export default Commission;
